import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { useProject } from "../project";

interface Input {
    scope: string[];
}

type Data = ClientInferResponseBody<typeof apiContract.createMeetingTrackerEmail, 200>;
interface Options {
    onSuccess?: (data: Data) => void;
}

export function useCreateMeetingTrackerMutation(options: Options) {
    const { project } = useProject();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.createMeetingTrackerEmail({
                body: {
                    projectId: project.id,
                    scope: input.scope,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to create meeting tracker email");
            }
            return res.body;
        },
        onSuccess: options.onSuccess,
    });
}
